import axios from 'axios';

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

const fetchHealthContent = ({ config, uri, reporter, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { healthBaseUrl } = config;
    const logger = reporter !== null && reporter !== void 0 ? reporter : console;
    try {
        const response = yield axios.get(`/r/document/${uri}`, {
            baseURL: healthBaseUrl,
            params: {
                bodyContentType: 'html',
            },
        });
        const { data: { result: { publishedPeriod: { latestRevision: { body, _id }, validityStart, validityEnd, }, contentType, }, }, } = response;
        return {
            body,
            validFrom: validityStart,
            validTo: validityEnd,
            versionId: _id,
            documentType: contentType,
        };
    }
    catch (err) {
        logger.error('Error on fetch health content', err);
        return null;
    }
});

const getLocaleFromUri = (uri) => {
    const uriParts = uri.split('/').filter((uriPart) => uriPart.trim() !== '');
    const localePart = uriParts[1];
    return localePart !== null && localePart !== void 0 ? localePart : null;
};

const maxRetries = 5;
const ECONNRESET_ERROR_CODE = 'ECONNRESET';
const fetchOtContent = ({ config, uri, reporter, locale, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { otBaseUrl } = config;
    const logger = reporter !== null && reporter !== void 0 ? reporter : console;
    const localeFromUri = getLocaleFromUri(uri);
    const preparedUri = localeFromUri
        ? uri.replace(`/${localeFromUri}`, '')
        : uri;
    const preparedLocale = localeFromUri !== null && localeFromUri !== void 0 ? localeFromUri : locale;
    if (!preparedLocale) {
        logger.error('Locale for URI is missing. Cannot fetch One Trust content.');
        return null;
    }
    let retries = 0;
    while (retries < maxRetries) {
        try {
            const response = yield axios.get(`/document/${preparedUri}/${preparedLocale}`, {
                baseURL: otBaseUrl,
            });
            const { data: { result: { contentType, publishedPeriod: { latestRevision: { _id, body }, }, }, }, } = response;
            return {
                body,
                versionId: _id,
                documentType: contentType,
            };
        }
        catch (err) {
            if (err.code === ECONNRESET_ERROR_CODE) {
                logger.info('Connection with OneTrust LDS Proxy reset, retrying...');
                retries += 1;
            }
            else {
                logger.error('Error on fetch One Trust content', err);
                return null;
            }
        }
    }
    logger.error(`Failed to establish connection with OneTrust LDS Proxy after ${maxRetries} retries.`);
    return null;
});

const LdsContentFetchers = {
    health: (_a) => __awaiter(void 0, void 0, void 0, function* () {
        var args = __rest(_a, []);
        return fetchHealthContent(Object.assign({}, args));
    }),
    ot: (_b) => __awaiter(void 0, void 0, void 0, function* () {
        var args = __rest(_b, []);
        return fetchOtContent(Object.assign({}, args));
    }),
};

var Platform;
(function (Platform) {
    Platform["Health"] = "health";
    Platform["HyHo"] = "hyho";
    Platform["OneTrust"] = "ot";
})(Platform || (Platform = {}));

export { LdsContentFetchers, Platform };
